module.exports = __webpack_public_path__ + "static/media/26_galeria_plantilla_navidad_menu_motivo_2.de84f96e.png";